import { api, appCommons } from '@/app/shared/services';

import { apiConstants } from '../../config';
import * as moment from "moment/moment";

const fetchGuide = (payload) => {
  const url = apiConstants.fetchGuide;

  // return api.post(url, payload);
  return api.get(url);
};

const fetchTags = (payload) => {
  const url = apiConstants.fetchTags;

  // return api.post(url, payload);
  return api.get(url);
};

const fetchArtefacts = (payload) => {

  let scopeList = [];
  let tagList = [];
  let refList = [];
  let filterList = [''];
  let paramsList = [];

  let endpoint = apiConstants[payload.type.toLowerCase()];

  if(payload.tags) {
    paramsList.push('&mode='+payload.mode);
    for(var tag of payload.tags) {
      if(tag.type === 'B') {
        paramsList.push('&brand='+tag.tag);
      }
      if(tag.type === 'C') {
        paramsList.push('&cat='+tag.tag);
      }
      if(tag.type === 'G') {
        paramsList.push('&sub_cat='+tag.tag);
      }
      if(tag.type === 'D') {
        paramsList.push('&dep='+tag.tag);
      }
    }
  }
  if(payload.mode === 'def' && payload.filters) {
    for(var tag of payload.filters) {
      if(tag.status) {
        filterList.push(tag.code);
      }
    }
  }

  if(scopeList.length === 0) {
    scopeList = appCommons.currentScope();
  }

  let params = {
    data: {
      "search_str":payload.query,
      "page_size":payload.page ? payload.page.size : 1,
      "current_page":payload.page.pos,
      "search_params":filterList.join('')
    }
  }

  let filters = filterList.join('&search_params=');
  let urlParams = paramsList.join('');

  endpoint = endpoint+'?search_str='+payload.query+'&page_size='+(payload.page ? payload.page.size : 1)+'&current_page='+payload.page.pos+filters+urlParams;
  // return api.get(endpoint);
  return api.query(endpoint, params);
};

const fetchArtefact = (payload) => {

  let scopeList = [];
  let tagList = [];
  let refList = [];
  let endpoint = apiConstants[payload.type.toLowerCase()];

  if(payload.tags) {
    for(var tag of payload.tags) {
      if(tag.type === 'S') {
        scopeList.push(tag.code);
      }
      if(tag.type === 'B') {
        tagList.push(tag.tag);
      }
      if(tag.type === 'C') {
        refList.push(tag.tag);
      }
    }

    if(scopeList.length === 0) {
      scopeList = appCommons.currentScope();
    }
  }

  let params = {

  }

  // return api.get(endpoint);
  if(payload.dateRange && payload.dateRange.startDate) {
    let startDate = moment(payload.dateRange.startDate);
    let endDate = moment(payload.dateRange.endDate);

    endpoint = endpoint+'?date_start='+startDate.format('Y-MM-DD')+'&date_end='+endDate.format('Y-MM-DD');
  }

  return api.query(endpoint, params);
};

const fetchArtefactUnit = (payload) => {

  let scopeList = [];
  let tagList = [];
  let refList = [];
  let endpoint = apiConstants[payload.type.toLowerCase()];

  if(payload.tags) {
    for(var tag of payload.tags) {
      if(tag.type === 'S') {
        scopeList.push(tag.code);
      }
      if(tag.type === 'B') {
        tagList.push(tag.tag);
      }
      if(tag.type === 'C') {
        refList.push(tag.tag);
      }
    }

    if(scopeList.length === 0) {
      scopeList = appCommons.currentScope();
    }
  }

  let params = {

  }

  endpoint = endpoint+ (payload.query ? "/"+payload.query+"//" : "");
  return api.query(endpoint, params);
};

export { fetchGuide, fetchTags, fetchArtefacts, fetchArtefact, fetchArtefactUnit };
